// extracted by mini-css-extract-plugin
export default {"content":"card_content__f7gyH"};